/**
 * 外包（供应商端）充值发起页。
 * 供应商端角色固定 SUPPLIER，entry 固定 SUPPLIER，isExternal=true；
 * overseas 由入口位置传入（供应商端已从上下文明确国内/海外）。
 * 复用公共层 RechargeFormView 渲染（formConfig 自动隐藏预算/定标/执行日期/超充/提前充值等字段）。
 */
import React from 'react';
import { RechargeFormView } from '@mpc/common/src/features/RechargeRefund/Drawer/RechargeFormView';

export interface OutRechargeFormProps {
  visible: boolean;
  onClose: () => void;
  onOk?: () => void;
  l2_demand_id: number;
  l3_demand_id?: number;
  recharge_order_id?: number;
  /** 由供应商端入口上下文传入（国内/海外） */
  overseas: boolean;
}

const OutRechargeForm: React.FC<OutRechargeFormProps> = (props) => (
  <RechargeFormView
    {...props}
    onCancel={props.onClose}
    initiator_role="SUPPLIER"
    entry="SUPPLIER"
    isExternal
  />
);

export default OutRechargeForm;
